module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "غرور-طاووس"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("غُرُورُ طَاوُوسٍ")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كَعَادَتِهِ كُلَّ صَبَاحٍ، وَقَفَ الطَّاوُوسُ مَزْهُوًا بِنَفْسِهِ، مُتَبَاهِيًا بِجَمَالِ رِيشِهِ، مُعْجَبًا بِأَلْوَانِهِ عَلَى صَدِيقِهِ الطَّاوُوسِ الآَخَرِ المَرِيضِ")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5cdf2baad7e4001c970b2c",
      "target": "_blank"
    }
  }, [_vm._v("الَّذِي انْتُزِعَ رِيش")]), _vm._v("ُهُ بِالْكَامِلِ، "), _c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5cdf2baad7e4001c970b2c",
      "target": "_blank"
    }
  }, [_vm._v("وَاعْتَزَلَ الْغَابَةَ وَمَا بِهَا مِنْ طُيُور")]), _vm._v("ٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("تَنَاسَى ذَلِكَ الطَّاوُوسُ الْمَغْرُورُ الصَّبَاحَاتِ الْجَمِيلَةَ الَّتِي كَانَ يَقْضِيهَا بِصُحْبَةِ صَدِيقِهِ الطَّاوُوسِ الْمَرِيضِ، "), _c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5cdf2baad7e4001c970b2c",
      "target": "_blank"
    }
  }, [_vm._v("مُتَنَكِّرًا لِذَلِكَ")]), _vm._v("، "), _c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5cdf2baad7e4001c970b2c",
      "target": "_blank"
    }
  }, [_vm._v("مُخَاطِبًا صَدِيقَهُ فِي خُيَلَاءَ وهوَ يَسْخَرُ مِنْهُ قَائِلًا")])]), _vm._v(":")]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَا يُوجَدُ أَحَدٌ فِي الغَابَةِ مِثْلِي فِي جَمَالِ رِيشِي!")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "16px",
      "padding-bottom": "16px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5cdf2baad7e4001c970b2c",
      "target": "_blank"
    }
  }, [_vm._v("يَا صَاحِب")]), _vm._v(" الرِّيشِ المُمَزَّقِ، إِلَى مَتَى سَتَبْقَى عَلَى هَذِهِ الْحَالِ؟ لَمْ تَعُدْ مِثْلِي،")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فابْحَثْ عَنْ مَكَانٍ قَصِيٍّ مِنْ هُنَا وَابْتَعِدْ!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5ce043aad7e4001c970b7a",
      "target": "_blank"
    }
  }, [_vm._v("قَال")]), _vm._v(" الطَّاووسُ الآخَرُ المَرِيضُ لِلطَّاووسِ الْمَغْرُورِ"), _c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5ce043aad7e4001c970b7a",
      "target": "_blank"
    }
  }, [_vm._v(":")])])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5ce043aad7e4001c970b7a",
      "target": "_blank"
    }
  }, [_vm._v("أَعْلَمُ أَنَّ رِيشَكَ جَميلٌ،")]), _vm._v(" لِتَحْمَدِ اللهَ،")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وَلَكِنْ نَحْنُ أَصْدِقَاءُ مُنْذُ زَمَنٍ، وَمَا أَنَا فِيهِ كُلُّ وَاحِدٍ يُمْكِنُ أَنْ يَتَعَرَّضَ لَهُ؛ لِمَاذَا هَذَا الْغُرُورُ؟!قَالَ لَهُ الطَّاووسُ الأوَّلُ:هَذَا الْكَلَامُ لَا يُجْدِي الآَنَ، لِمَاذَا لَا تَرْحَلُ إِلَى مَكَانٍ آَخَرَ أَنْتَ")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وَهَذَا الرِّيشُ الْمُمَزَّقُ؟"), _c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5ce2a9aad7e4001c970c3c",
      "target": "_blank"
    }
  }, [_vm._v("!")])])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "16px",
      "padding-bottom": "16px"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("****")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5ce2a9aad7e4001c970c3c",
      "target": "_blank"
    }
  }, [_vm._v("آَثَرَ الطَّاووسُ الآَخَرُ الصَّمْتَ، وَكَانَ يَزْحَفُ بِبُطْءٍ سَاحِبًا مَعَهُ أَحْزَانَهُ")]), _vm._v(" لِيُشَارِكَ مَا بِهِ ذَلِكَ الْحَقْلَ الْخَصِيبَ بِكُلِّ مَا فِيهِ مِنْ جَمَالِ الأَزْهَارِ، وَالْفَرَاشَاتِ، وَالْعَصَافِيرِ، وَالأَنْهَارِ،")]), _vm._v(" "), _c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5ce2a9aad7e4001c970c3c",
      "target": "_blank"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وَيَدْعُو اللهَ")])]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أَنْ يُعِيدَ لَهُ رِيشَهُ، مُخَاطِبًا نَفْسَهُ: لِمَاذَا يَعْمَلُ مَعِي صَدِيقِي الطَّاوُوسُ كُلَّ هَذَا؟ مَعَ أَنَّ كُلَّ وَاحِدٍ مِنَّا مُعَرَّضٌ لِلْمَرَضِ! بَدَلًا أَنْ يَقِفَ بِجَانِبِي، يَقِفُ مُخْتَالًا فَخُورًا مُتَكَبِّرًا بِمَا أَنْعَمَ عَلَيْهِ بِهِ اللهُ"), _c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5ce2a9aad7e4001c970c3c",
      "target": "_blank"
    }
  }, [_vm._v("!")])])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لَا يَبْقَى شَيْءٌ عَلَى حَالِهِ؛")]), _vm._v(" "), _c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5ce2a9aad7e4001c970c3c",
      "target": "_blank"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("فَقَدْ تَبَدَّلَتِ")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("الأيَّام")])]), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ُ، وَمَرِضَ الطَّاوُوسُ الْمَغْرُورُ، وَتَمَزَّقَ كُلُّ رِيشِهِ، وَأَصْبَحَ مَعْزُولًا،")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5ce305c48568001cfeab13",
      "target": "_blank"
    }
  }, [_vm._v("بَيْنَمَا صَدِيق")]), _vm._v("ُهُ الطَّاوُوسُ الْمَرِيضُ عَادَ لَهُ رِيشُهُ بَعْدَ دُعَاءِ اللهِ، وَلَمْ يَتْرُكْ صَدِيقَهُ الطَّاوُوسَ الْمَغْرُورَ فِي مَرَضِهِ، وَأَخَذَ يُوَاسِيهِ وَيُخَفِّفُ عَنْهُ، وَيُسَاعِدُهُ فِي الْعِلَاجِ،")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('a', {
    staticClass: "unclickable-link",
    attrs: {
      "href": "https://www.rqiim.com/kosasa/5f5ce305c48568001cfeab13",
      "target": "_blank"
    }
  }, [_vm._v("إِلَى أَنِ اسْتَرَدَّ رِيشَ")]), _vm._v("هُ، وَبِذَلِكَ تَعَلَّمَ الطَّاوُوسُ الْمَغْرُورُ دَرْسًا بِأَلَّا يُؤْذِيَ أَحَدًا، وَأَنْ يَبْتَعِدَ عَنِ الْغُرُورِ وَالْخُيَلَاءِ،")]), _vm._v(" "), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وَقَدْ أَصْبَحَتِ الصَّدَاقَةُ بَيْنَ الطَّاوُوسَيْنِ جَمِيلَةً، وَكُلُّ وَاحِدٍ مِنْهُمَا يُحِبُّ الْخَيْرَ لِلآخَرِ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bf6fc54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 72
// module chunks = 0